import '@devlit/react-pdfjs/dist/index.css';

import _ from 'lodash';
import React, { Component } from 'react';

import Pdfjs from '@devlit/react-pdfjs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as CourseActions } from '../../../store/ducks/newCourse/actions';
import { gateway } from '../../../utils/api';
import ViewEditor from '../../shared/ViewEditor';

import * as Styles from './styles';

// import PdfViewer from "../../PdfViewer";
class Documento extends Component {
  state = {
    page: 0,
    codeObject: null,
    fullScreen: false,
    idProfile: parseInt(localStorage.getItem('idProfile'), 10),
    totalPages: 1
  };

  componentDidUpdate(prevProps) {
    // Resetar totalPages apenas se o documento mudou e não já foi resetado para essa URL
    if (!this.lastUrlSetState)
      this.lastUrlSetState = this.props.selected && this.props.selected.url;
    if (
      prevProps.selected &&
      this.props.selected &&
      prevProps.selected.url !== this.props.selected.url &&
      this.state.totalPages !== 1 &&
      this.lastUrlSetState !== this.props.selected.url
    ) {
      this.lastUrlSetState = this.props.selected.url;
      this.updateTotalPages(1);
    }
  }

  componentWillUnmount() {
    this.saveProgress('EXIT');
  }

  updateTotalPages = size => {
    this.setState({ totalPages: size });
  };

  setFullScreen = newFullScreen => {
    this.setState({ fullScreen: newFullScreen });
  };

  sendObjectProgress = (selected, idProfile, action, status) => {
    const { courseSession } = this.props;
    const sessionCourse = localStorage.getItem('session') || courseSession;
    const { code, courseCode } = selected;
    const rawPosition = _.get(
      selected,
      'contentProgress.ox_status.nx_value',
      1
    );
    const position = this.validatePosition(rawPosition);

    gateway.post(
      '/webbff/lit_app_web/course_progress/course_progress_object/',
      {
        selected: { code, courseCode },
        idProfile,
        courseSession: sessionCourse,
        action,
        status,
        type: 'PDF',
        position
      }
    );
  };

  validatePosition = position => {
    if (typeof position === 'string' && position.includes(':')) {
      return 1;
    }
    const numPosition = Number(position);

    if (Number.isNaN(numPosition)) {
      return 1;
    }
    if (numPosition <= 0) {
      return 1;
    }
    const { totalPages } = this.state;
    if (numPosition > totalPages) {
      return 1;
    }
    return Math.floor(numPosition);
  };

  saveProgress = action => {
    const { idProfile } = this.state;
    const { selected } = this.props;

    if (selected.typeContent === 'about') {
      return;
    }

    const rawPosition = _.get(
      selected,
      'contentProgress.ox_status.nx_value',
      1
    );
    const position = this.validatePosition(rawPosition);

    const progress = {
      idProfile,
      hierarchy: selected.hierarchy,
      contentCode: selected.code,
      courseCode: selected.courseCode,
      position,
      status: 'IN PROGRESS'
    };

    gateway
      .post('/webbff/lit_app_web/progress/saveProgress', progress)
      .then(() => console.log('RESPOSTA endOfFile'))
      .catch(err => console.log(err));
    this.sendObjectProgress(selected, idProfile, action, 'IN PROGRESS');
  };

  endOfFile = async () => {
    const { idProfile } = this.state;
    const {
      selected,
      setDisciplineProgress,
      incrementCourseProgress
    } = this.props;

    const progress = {
      idProfile,
      hierarchy: selected.hierarchy,
      courseCode: selected.courseCode,
      contentCode: selected.code,
      position: 1,
      status: 'DONE'
    };

    const objectStatusProgress = _.get(
      selected,
      'contentProgress.ox_status.wk_status',
      'IN_PROGRESS'
    );

    gateway
      .post('/webbff/lit_app_web/progress/saveProgress', progress)
      .then(response => {
        document
          .getElementById(`course-object-${selected.code}`)
          .classList.add('active');
        if (objectStatusProgress !== 'DONE') {
          const progress = _.get(response, 'progress', []);
          const foundObject = progress.find(
            p => p.rk_reference === selected.code
          );
          const status = _.get(foundObject, 'wk_status');
          incrementCourseProgress(status);
        }
        setDisciplineProgress(selected.idDiscipline);
      })
      .catch(err => console.log(err));

    this.sendObjectProgress(selected, idProfile, 'DONE', 'DONE');
  };

  onPageComplete = _.debounce(async ({ page, fullScreen, EOF, size }) => {
    const { page: pageState, codeObject, totalPages } = this.state;
    const { setPlayerPosition, selected } = this.props;
    if (size && size !== totalPages) {
      this.setState({ totalPages: size });
    }

    if (selected.typeContent === 'about' || selected.tags.includes('ABOUT')) {
      return;
    }
    setPlayerPosition(page);
    if (pageState !== page || codeObject !== selected.code) {
      this.setState({ page, codeObject: selected.code });
      if (!EOF) {
        this.saveProgress('CHANGE PAGE');
      }
    }

    if (EOF) {
      this.endOfFile();
    }
    if (this.state.fullScreen !== fullScreen) {
      this.setFullScreen(fullScreen);
      document.getElementById('body-conteudo').style.overflow = fullScreen
        ? 'hidden'
        : '';
      document.querySelector(
        'div[role="navigation"]'
      ).style.overflow = fullScreen ? 'hidden' : 'auto';
    }
  }, 1000);

  downloadAnexo = ({ path }) => {
    if (path) {
      const linkDownload = document.createElement('a');
      linkDownload.setAttribute('download', '');
      linkDownload.setAttribute('href', path);
      linkDownload.setAttribute('target', '_blank');
      linkDownload.click();
    }
  };

  render() {
    const { selected } = this.props;
    const pageFromProps = _.get(
      selected,
      'contentProgress.ox_status.nx_value',
      1
    );
    const safePage = this.validatePosition(pageFromProps);
    if (!selected.url) {
      return null;
    }
    const knowMoreList = this.props.selected.knowMore;

    return (
      <>
        <div id="pdf" className="row">
          <div className="col-md-12">
            <div id="pdf-div-id" className="pdf-wrapper">
              <Pdfjs
                onDownload
                onScrollMode
                onFullScreen
                page={safePage}
                file={selected.url}
                onUpdate={this.onPageComplete}
              />
            </div>
            {knowMoreList.length > 0 && <h4>SAIBA MAIS - Arquivos</h4>}
            {knowMoreList.length > 0 &&
              knowMoreList.map((item, index) => {
                const { media } = item;

                return (
                  <Styles.ItemContainer key={media.id}>
                    <Styles.ContainerIcon>
                      {media.type === 'BOOK'
                        ? media.type
                        : _.get(media, 'type', '?')}
                    </Styles.ContainerIcon>
                    <Styles.ItemDescription>
                      {_.get(media, 'name', '?')}
                    </Styles.ItemDescription>
                    {_.get(media, 'path', false) && (
                      <Styles.BtnDownload
                        type="button"
                        className="btn btn-light"
                        onClick={() => this.downloadAnexo({ path: media.path })}
                      >
                        <i className="fa fa-download" aria-hidden="true" />
                        <a target="" />
                      </Styles.BtnDownload>
                    )}
                  </Styles.ItemContainer>
                );
              })}
          </div>
        </div>
        <Styles.ObjectDescription>
          <ViewEditor
            data={selected.shortDescription || selected.longDescription}
          />
        </Styles.ObjectDescription>
      </>
    );
  }
}

const mapStateToProps = state => ({
  selected: state.newCourse.selected,
  course: state.newCourse.data,
  idCourse: state.newCourse.data.idCourse,
  playerPosition: state.newCourse.playerPosition,
  courseSession: state.newCourse.courseSession
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(CourseActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Documento);
